import React, { useMemo } from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { NetworkStatusHelper } from "../../../helpers/networkStatus.helper"
import type { INetworkStatusRulesFilters } from "../../../types/networkStatus.types"

import closeIcon from "@front-shared/assets/images/icons/close-input-control.svg"

export const NetworkStatusRulesFiltersDisplayComponent: React.FunctionComponent<
    INetworkStatusRulesFiltersDisplayComponentProps
> = props => {
    const mappedFilters = useMemo(
        () =>
            NetworkStatusHelper.getMappedDisplayFiltersForRules(props.filters),
        [props.filters],
    )

    if (!mappedFilters.length) {
        return null
    }

    return (
        <div
            className={`
                relative flex items-start
                ${props.className ?? ""}
            `}
        >
            <PrimaryText
                className="mr-[8px] mt-[12px] flex-shrink-0"
                typography="h6"
            >
                {props.prefixLabel ?? "Filtering by:"}
            </PrimaryText>

            <div className="mt-[9px] flex items-center flex-wrap gap-2">
                {mappedFilters.map((item, index) => {
                    const filterKey =
                        item.key as keyof INetworkStatusRulesFilters

                    return (
                        <div
                            key={index}
                            className="rounded-[22px] bg-brand-warmLight flex justify-between"
                        >
                            <PrimaryText
                                className="pl-[16px] pt-[8px] pb-[6px] pr-[16px]"
                                size={14}
                                lineHeight={14}
                            >
                                {item.label}: {item.value}
                            </PrimaryText>

                            <button
                                className="cursor-pointer pl-[12px] pr-[16px] rounded-r-[22px]"
                                type="button"
                                onClick={() => {
                                    props.onRemoveFilter(filterKey)
                                }}
                            >
                                <img src={closeIcon} alt="Remove" />
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

interface INetworkStatusRulesFiltersDisplayComponentProps {
    className?: string
    prefixLabel?: string
    filters: INetworkStatusRulesFilters
    onRemoveFilter: (key: keyof INetworkStatusRulesFilters) => void
}
